import * as RadixVisuallyHidden from '@radix-ui/react-visually-hidden';

const VisuallyHidden = ({
  ...props
}: React.ComponentProps<typeof RadixVisuallyHidden.Root>) => (
  <RadixVisuallyHidden.Root {...props} />
);

VisuallyHidden.displayName = 'VisuallyHidden';

export { VisuallyHidden };
